import React from "react";
import { useEffect } from "react";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { Box } from "@mui/material";

import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { useLocation } from "react-router-dom";

import LearnTextEmbed from "./LearnCopy/LearnTextEmbed";

import glossaryJson from "./LearnCopy/Glossary.json";

const paperPadding = 2;

/* 
  PortfolioSummary Component is the component that renders a portfolio summary
*/
function LearnPanel() {
  const theme = useTheme();
  const fixedSizeForSideSquares = theme.spacing(50);

  const location = useLocation();
  const hash = location.hash.replace("#", "").replaceAll("%20", " ") || "";

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  // const [colorHash, setColorHash] = useEffect(() => {
  //   if (hash) {
  //   }
  // }, [hash]);

  return (
    <Stack
      sx={{
        display: "flex",
        height: "100%",
        flexDirection: "row",
        gap: 2,
      }}
    >
      <Paper
        sx={{
          flexGrow: 1,
          px: paperPadding,
          pb: paperPadding,
          sizing: "border-box",
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
          maxWidth: "800px",
          overflow: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            maxWidth: "800px",
          }}
        >
          <Box
            sx={{
              flexShrink: 0,
              width: "100%",
              height: theme.spacing(paperPadding),
              backgroundColor: theme.palette.background.paper,
            }}
          />
          {glossaryJson.map((entry, index) => {
            return (
              <Box
                key={index}
                id={entry.term}
                sx={{
                  scrollMarginTop: theme.typography.h6.fontSize,
                  border: 1,
                  borderColor:
                    hash.toLowerCase() === entry.term.toLowerCase()
                      ? theme.palette.primary.light
                      : theme.palette.background.paper,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    position: "sticky",
                    top: 0,
                    backgroundColor: theme.palette.background.paper,
                  }}
                >
                  <Box
                    sx={{
                      ml: 2,
                    }}
                  >
                    {/* <IconButton
                    onClick={() => props.handleAdd !== undefined && props.handleAdd(key)}
                    disabled={props.spinAddStrategy === key}
                  >
                    {<AddIcon />}
                  </IconButton> */}
                  </Box>
                  <Typography
                    variant="h6"
                    color={theme.palette.primary.main}
                    sx={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      pt: 1,
                    }}
                  >
                    {entry.term}
                  </Typography>
                </Box>
                <Typography variant="body1" color={theme.palette.text.primary} sx={{ px: 2, pb: 1 }}>
                  {<LearnTextEmbed content={entry.definition.trim()} replaceTab />}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Paper>
      <Paper
        sx={{
          width: fixedSizeForSideSquares,
          flexShrink: 0,
          padding: paperPadding,
          // marginBottom: { xs: 0, lg: 2 },
          // marginRight: { xs: 2, lg: 0 },
          boxSizing: "border-box",
          overflow: "auto",
          display: { xs: "none", lg: "initial" },
        }}
      >
        <Typography variant="h6" color={theme.palette.info.main} sx={{ pb: 0.5 }}>
          Jump to
        </Typography>
        {glossaryJson.map((entry, index) => (
          <a
            key={index}
            href={"#" + entry.term}
            style={{
              textDecoration: "none",
            }}
          >
            <Typography
              variant="body1"
              color={
                hash.toLowerCase() === entry.term.toLowerCase()
                  ? theme.palette.primary.main
                  : theme.palette.text.secondary
              }
              sx={{
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                // backgroundColor: hash === entry.term ? theme.palette.primary.light : undefined,
                pb: 0.5,
              }}
            >
              {entry.term}
            </Typography>
          </a>
        ))}
      </Paper>
    </Stack>
  );
}

export default LearnPanel;
